import React, { useContext } from "react";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import { StoreContext } from "../../../store";
import "./index.css";

const style = {
  position: "absolute",
  top: "5rem",
  left: "50%",
  transform: "translate(-50%, 0)",
  width: "50%",
  minWidth: "20rem",
  bgcolor: "background.paper",
  border: "0.1rem solid #017EFA",
  boxShadow: 24,
  borderRadius: "1rem",
  padding: "1rem 0 1rem 2.5rem"
};

function ModalBox(props) {
  const context = useContext(StoreContext);
  return (
    <Modal
      open={context.modalOpen}
      className={`modalBox ${props.class ?? ""}`}
      onClose={() => context.setModalOpen(false)}
    >
      <Box sx={style}>
        <div className="modalHeader">
          <h5>{props.title}</h5>
          <div
            className="closeIcon"
            onClick={() => context.setModalOpen(false)}
          >
            <CloseIcon />
          </div>
        </div>
        {props.children}
      </Box>
    </Modal>
  );
}

export default ModalBox;
